export default {"src":"/_next/static/media/motion-blur-2.4067caaa.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};